import { createSelector } from "reselect";
import { RootState } from "../../rootReducer";

export const selectDocumentsStatus = createSelector(
  [(store: RootState) => store.utils.status],
  (statusList) => statusList.filter(({ module }) => module === "document")
);
